export type Testimonial = {
  quote: string
  name: string
  location: string
  project: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      "Honest, skilled, and reliable. I couldn't be happier with my kitchen remodel!",
    name: 'Emily T.',
    location: 'Parker, CO',
    project: 'Kitchen remodel'
  },
  {
    quote:
      'I wanted something unique — a statement piece that reflected my personal style — and Restored Services got it. They built the most beautiful custom bookshelves I’ve ever seen, blending function and artistry seamlessly. My space finally feels like me.',
    name: 'Mallory D.',
    location: 'Englewood, CO',
    project: 'Custom carpentry'
  },
  {
    quote:
      'I don’t trust just anyone to work on my home, but Restored Services put my mind at ease from the start. They walked me through the whole process, gave me a fair quote, and stuck to it. My deck is solid and looks great.',
    name: 'Daniel H.',
    location: 'Parker, CO',
    project: 'Deck build'
  },
  {
    quote:
      'The crew was punctual, professional, and precise. They cleaned up every single nail after the roof replacement, and the final product was flawless. If you want the job done right, this is the team to call!',
    name: 'Elizabeth R.',
    location: 'Highlands Ranch, CO',
    project: 'Roof replacement'
  },
  {
    quote:
      'I run a busy household and needed a team that could deliver fast, high-quality results. My kitchen looks like something out of a magazine, and they finished ahead of schedule.',
    name: 'Jason T.',
    location: 'Greenwood Village, CO',
    project: 'Kitchen remodel'
  },
  {
    quote:
      'From the moment they stepped into my home, I felt taken care of. The team went above and beyond to make sure my bathroom remodel was perfect. They even helped me pick out the best tile for my space!',
    name: 'Susan W.',
    location: 'Centennial, CO',
    project: 'Bathroom remodel'
  },
  {
    quote:
      'My floors were in desperate need of an upgrade. From start to finish, they were responsive, professional, and detail-oriented. The new floors have completely transformed my space.',
    name: 'Michael P.',
    location: 'Lakewood, CO',
    project: 'Flooring'
  },
  {
    quote:
      'They handled my full home renovation with confidence, efficiency, and quality craftsmanship. No nonsense, no delays, just solid work. I’d recommend them to anyone serious about getting a project done right.',
    name: 'Brian L.',
    location: 'Aurora, CO',
    project: 'Whole-home renovation'
  },
  {
    quote:
      'WOW, what an amazing experience! These guys built me an outdoor kitchen that is next-level awesome. They made the whole process fun and stress-free, and now I’m the go-to house for summer BBQs.',
    name: 'Becky J.',
    location: 'Castle Rock, CO',
    project: 'Outdoor kitchen'
  }
]
